export enum TableColumnType {
  Text = "TEXT",
  Date = "DATE",
  Number = "NUMBER",
}

export enum TooltipDirection {
  bottomRight = "bottom-right",
  bottomLeft = "bottom-left",
  topRight = "top-right",
  topLeft = "top-left",
}
